import React from "react";
import { shouldSkipAuth } from "../../App";
import { Authenticator } from "@aws-amplify/ui-react";

type AuthenticatorWrapperProps = {
  children: React.ReactNode;
};
function AuthenticatorWrapper({ children }: AuthenticatorWrapperProps) {
  return <>{shouldSkipAuth() ? children : React.createElement(Authenticator, { hideSignUp: true, children: ({}) => children } as never)}</>;
}

export default AuthenticatorWrapper;
